import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  FormControlLabel,
  Checkbox
} from '@mui/material';

export default function DeletedFuelHistoryConfirmedDialog({ open, loading, onClose, onConfirm, targetText }) {
  const [inputValue, setInputValue] = useState('');
  const [isAgreed, setIsAgreed] = useState(false);

  useEffect(() => {
    if (open) {
      setInputValue('');
      setIsAgreed(false);
    }
  }, [open]);

  const handleClose = () => {
    if (loading) return;
    if (onClose) onClose();
  };

  const handleConfirm = () => {
    if (inputValue === targetText && isAgreed) {
      if (onConfirm) onConfirm();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Delete Fuel Price History</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <Typography variant="body1" gutterBottom color="error" sx={{ fontWeight: 600 }}>
            WARNING: Deleting this fuel price history cannot be undone!
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            If you are absolutely sure you want to delete this record, please type the exact text <strong>{targetText}</strong> correctly
            below:
          </Typography>
          <TextField
            fullWidth
            size="small"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder={targetText || 'Enter fuel price history info'}
            sx={{ mb: 2 }}
          />
          <FormControlLabel
            control={<Checkbox checked={isAgreed} onChange={(e) => setIsAgreed(e.target.checked)} color="error" />}
            label={<Typography variant="body2">Please check this box if you understand the rules regarding data deletion.</Typography>}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading} color="inherit">
          Cancel
        </Button>
        <Button onClick={handleConfirm} disabled={loading || inputValue !== targetText || !isAgreed} color="error" variant="contained">
          {loading ? 'Deleting...' : 'Confirm Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
